/**
 * Parse a trip-related date string into a Date.
 *
 * Calendar-only values ("YYYY-MM-DD") and UTC-midnight ISO timestamps
 * ("YYYY-MM-DD...T00:00:00Z") are treated as local noon so they don't
 * render as the previous day in timezones west of UTC. Full ISO
 * timestamps with a time component are parsed as-is.
 */
export function parseTripDate(iso: string): Date {
  const match = /^(\d{4}-\d{2}-\d{2})(?:[T ]00:00:00(?:\.\d+)?Z?)?$/.exec(iso)
  return match ? new Date(`${match[1]}T12:00:00`) : new Date(iso)
}
